import { createSlice } from '@reduxjs/toolkit';

// Load theme from localStorage, default to 'light' if not found
const savedTheme = localStorage.getItem('theme') || 'light';

const initialState = {
  sideNavOpen: false,
  sideNavCollapsed: false,
  loading: false,
  notifications: [],
  theme: savedTheme,
  breadcrumbs: [],
  modal: {
    isOpen: false,
    type: null,
    data: null,
  },
  snackbar: {
    open: false,
    message: '',
    severity: 'info', // 'error', 'warning', 'info', 'success'
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSideNav: (state) => {
      state.sideNavOpen = !state.sideNavOpen;
    },
    setSideNavOpen: (state, action) => {
      state.sideNavOpen = action.payload;
    },
    toggleSideNavCollapsed: (state) => {
      state.sideNavCollapsed = !state.sideNavCollapsed;
    },
    setSideNavCollapsed: (state, action) => {
      state.sideNavCollapsed = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        ...action.payload,
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload;
    },
    openModal: (state, action) => {
      state.modal = {
        isOpen: true,
        type: action.payload.type,
        data: action.payload.data || null,
      };
    },
    closeModal: (state) => {
      state.modal = {
        isOpen: false,
        type: null,
        data: null,
      };
    },
    showSnackbar: (state, action) => {
      state.snackbar = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'info',
      };
    },
    hideSnackbar: (state) => {
      state.snackbar = {
        ...state.snackbar,
        open: false,
      };
    },
  },
});

export const {
  toggleSideNav,
  setSideNavOpen,
  toggleSideNavCollapsed,
  setSideNavCollapsed,
  setLoading,
  addNotification,
  removeNotification,
  clearNotifications,
  setTheme,
  setBreadcrumbs,
  openModal,
  closeModal,
  showSnackbar,
  hideSnackbar,
} = uiSlice.actions;

export default uiSlice.reducer;
